import { ReactComponent as IntroTourLanguageIcon } from "assets/icons/intro-tour-dialog-language.svg";
import { MenuItem } from "./types";
import langSwitchVideo from "assets/videos/lang_switch_EN.mov";
import playbackVideo from "assets/videos/playback_download_EN.mov";
import sayAsVideo from "assets/videos/say-as_EN.mov";
import { TFunction } from "i18next";

// Import video covers
import languageVideoCover from "assets/video-covers/language-video-cover.svg";
import playbackDownloadVideoCover from "assets/video-covers/playback-download-video-cover.svg";
import sayasVideoCover from "assets/video-covers/sayas-video-cover.svg";

export const getMenuItems = (t: TFunction): MenuItem[] => [
  // {
  //   label: t("tts.introTour.menuItems.scriptSettings.label"),
  //   title: t("tts.introTour.menuItems.scriptSettings.title"),
  //   subtitle: t("tts.introTour.menuItems.scriptSettings.subtitle"),
  //   description: t("tts.introTour.menuItems.scriptSettings.description"),
  //   icon: <IntroTourLanguageIcon />,
  //   videoUrl: null, // No video for this section yet
  // },
  {
    label: t("tts.introTour.menuItems.languageSwitch.label"),
    title: t("tts.introTour.menuItems.languageSwitch.title"),
    subtitle: t("tts.introTour.menuItems.languageSwitch.subtitle"),
    description: t("tts.introTour.menuItems.languageSwitch.description"),
    icon: <IntroTourLanguageIcon />,
    videoUrl: langSwitchVideo,
    coverImage: languageVideoCover,
  },
  {
    label: t("tts.introTour.menuItems.sayAs.label"),
    title: t("tts.introTour.menuItems.sayAs.title"),
    subtitle: t("tts.introTour.menuItems.sayAs.subtitle"),
    description: t("tts.introTour.menuItems.sayAs.description"),
    icon: <IntroTourLanguageIcon />,
    videoUrl: sayAsVideo,
    coverImage: sayasVideoCover,
  },
  // {
  //   label: t("tts.introTour.menuItems.prosody.label"),
  //   title: t("tts.introTour.menuItems.prosody.title"),
  //   subtitle: t("tts.introTour.menuItems.prosody.subtitle"),
  //   description: t("tts.introTour.menuItems.prosody.description"),
  //   icon: <IntroTourLanguageIcon />,
  //   videoUrl: null,
  // },
  // {
  //   label: t("tts.introTour.menuItems.phonemes.label"),
  //   title: t("tts.introTour.menuItems.phonemes.title"),
  //   subtitle: t("tts.introTour.menuItems.phonemes.subtitle"),
  //   description: t("tts.introTour.menuItems.phonemes.description"),
  //   icon: <IntroTourLanguageIcon />,
  //   videoUrl: null, // No video for this section yet
  // },
  {
    label: t("tts.introTour.menuItems.playback.label"),
    title: t("tts.introTour.menuItems.playback.title"),
    subtitle: t("tts.introTour.menuItems.playback.subtitle"),
    description: t("tts.introTour.menuItems.playback.description"),
    icon: <IntroTourLanguageIcon />,
    videoUrl: playbackVideo,
    coverImage: playbackDownloadVideoCover,
  },
];
